import script from "./BinaryOptionsVol2Form.vue?vue&type=script&setup=true&lang=js"
export * from "./BinaryOptionsVol2Form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__